import React from 'react';
import Page from '../../layout/Page';
import SingleUseCodes from './SingleUseCodes';
import Button from '../../forms/Button';
import Row from '../../layout/Row';
import Form from '../../forms/Form';
import Input from '../../forms/Input';
import ReceiptCodes from './ReceiptCodes';
import { userRoles } from '../../RoleProtected';
import Settings from './Settings';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import Col from '../../layout/Col';
import { shortHandDate } from '../../utility/functions';
import ModalFactory from '../../Modal';

export const voidCode = code => {
    return new Promise(async (resolve, reject) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to Void ${code}?`,
                type: 'warning',
            },
            promise: {
                title: 'Voiding',
                body: `Voiding ${code}`,
                callback: () => HamQuest.put(QuestRoute.codes.void(code), { isVoided: true })
            },
            confirmed: {
                title: 'Success',
                body: `${code} successfully voided.`,
                type: 'success'
            },
            finally: () => resolve(true)
        })
    })
}

export const codeLookUp = () => {
    ModalFactory.show({
        title: 'Code Lookup',
        body: (
            <Form
                inputs={{ code: '' }}
                onSubmit={e => (
                    HamQuest.getQuery(QuestRoute.codes.lookup, { ...e })
                        .then(res =>
                            ModalFactory.show({
                                title: 'Details',
                                body: (
                                    <Col>
                                        <Row justify='space-between'>Code: <span>{res.code}</span></Row>
                                        <Row justify='space-between'>Code Type: <span>{res.codeType}</span></Row>
                                        <Row justify='space-between'>Issue Date:  <span>{shortHandDate(res.issueDate)}</span></Row>
                                        <Row justify='space-between'>Expiration Date: <span>{shortHandDate(res.expirationDate)}</span></Row>
                                        <Row justify='space-between'>Redeemed Date: <span>{shortHandDate(res.lastUsedDate)}</span></Row>
                                        <Row justify='space-between'>Max Uses: <span>{res.maxUses}</span></Row>
                                        <Row justify='space-between'>Remaining Uses: <span>{res.maxUses - res.useLimitCount}</span></Row>
                                        <Row justify='space-between'>Description: <span>{res.description}</span></Row>
                                        <Row justify='space-between'>Voided: <span>{res.isVoided ? 'Yes' : <Button onClick={() => voidCode(res.code)}>Void Code</Button>}</span></Row>
                                    </Col>
                                )
                            }))
                        .catch(ModalFactory.catch)
                )}
                text='Look Up'
            >
                <Input
                    label='Code'
                    name='code'
                    type='number'
                    required
                />
            </Form>
        )
    })
}

const Codes = ({ ...props }) => {

    return (
        <Page
            title='Codes'
            tabTitle='Codes'
            icon='QRcode'
            controls={<Button onClick={codeLookUp}>Look Up</Button>}
            tabs
        >
            <SingleUseCodes tab='Single Use Codes' roles={userRoles.issueRewash} />
            <ReceiptCodes tab='Receipt Codes' roles={userRoles.viewProducts} />
            <Settings tab='Settings' roles={userRoles.viewProducts} />
        </Page >
    );
}

export default Codes;